import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import mime from 'mime-types';
import moment from 'moment';
import classnames from 'classnames';
import FilePreview from '../../../FilePreview';
import AnimatedUploadingFilePopUp from '../../../AnimatedUploadingFilePopUp';
import styles from './styles.module.scss';

export function FileItem({
                           fileID,
                           uploadTime,
                           fileName,
                           ttHelkaID,
                           shumaId,
                           stepId,
                           fileExtension,
                           closeModal,
                           getStepData,
                           showGlobalErrorMessage,
                           handleSubmit,
                           getFile,
                           showShumaIdColumn,
                           originShumaID,
                           copyFile,
                           fileTypeID,
                           showHelkaColumn,
                           getFileList
                         }) {
  const [content, setContent] = useState(false);
  const [fileType, setFileType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [previewIsOpen, setPreviewIsOpen] = useState(false);
  const openPreview = () => setPreviewIsOpen(true);
  const closePreview = () => setPreviewIsOpen(false);

  const updateFile = async () => {
    setFileType(null);
    setContent(null);
    const body = await getFile({shumaID: shumaId, fileID});
    const mimeType = mime.lookup(fileExtension);
    const dataUri = `data:${mimeType};base64,${body}`;
    setContent(dataUri);
    setFileType(getType());

    return dataUri;
  };

  const handleFileOpen = () => {
    if (getType()) {
      Promise.resolve()
        .then(() => setLoading(true))
        .then(() => setFileType('spinner'))
        .then(updateFile)
        .then(() => openPreview())
        .catch((e) => {
          setFileType(null);
          showGlobalErrorMessage(e.message);
          closePreview();
        })
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    setFileType(getType());
  }, [fileID]);

  const getType = () => {
    switch (mime.lookup(fileExtension)) {
      case 'application/pdf':
        return 'pdf';
      case 'image/gif':
      case 'image/jpeg':
      case 'image/jpg':
      case 'image/tiff':
      case 'image/png':
        return 'image';
      default:
        return null;
    }
  };

  const handleCopyFile = () => {
    Promise.resolve()
      .then(() => {
        setLoading(true);
      })
      .then(() => {
        if (fileTypeID) {
          return copyFile(shumaId, fileID, fileTypeID);
        } else {
          return copyFile(shumaId, fileID);
        }
      })
      .then(() => handleSubmit())
      .catch(err => showGlobalErrorMessage(err.message))
      .then(() => {
        setLoading(false);
      })
      .then(() => {
        getStepData({shumaId, stepId});
        getFileList({shumaId})
      })
      .then(() => {
        closeModal();
      });
  };

  return (
    <>
      <div
        key={fileID}
        className={styles.filesListContainer}
      >
        <div className={classnames(styles.gridItem, styles.date)}>
          {moment.utc(uploadTime).format('DD-MM-YYYY HH:mm:ss')}
        </div>
        {showShumaIdColumn && (
          <div className={classnames(styles.gridItem, styles.shumaID)}>
            {originShumaID}
          </div>
        )}
        <div className={classnames(styles.gridItem, styles.fileName, {
          [styles.shorted]: showShumaIdColumn, [styles.increased]: !showHelkaColumn,
        })}>
          <span
            dir="ltr"
            onClick={handleFileOpen}
          >
            {fileName}
          </span>
        </div>
        {showHelkaColumn && (
          <div className={classnames(styles.gridItem, styles.ttHelka)}>
            {ttHelkaID}
          </div>
        )}
        <div className={classnames(styles.gridItem, styles.selectButton)}>
          <div
            onClick={handleCopyFile}
            className={styles.actionButton}
          >
            בחר
          </div>
        </div>
      </div>
      <AnimatedUploadingFilePopUp show={loading}/>
      <FilePreview
        isOpen={previewIsOpen}
        close={closePreview}
        dataURI={content}
        type={fileType}
      />
    </>
  );
}

FileItem.propTypes = {
  getFile: PropTypes.func,
  showShumaIdColumn: PropTypes.bool,
  originShumaID: PropTypes.number,
  copyFile: PropTypes.func
};
